import { Box, Group, Progress, Text } from "@mantine/core";

export function pct(used: number, total: number): number {
  if (total <= 0) return 100;
  return Math.min(100, Math.round((used / total) * 100));
}

export function QuotaBar({
  label,
  used,
  total,
  unit,
}: {
  label: string;
  used: number;
  total: number;
  unit: string;
}) {
  const remaining = Math.max(0, total - used);
  const p = pct(used, total);
  return (
    <Box>
      <Group justify="space-between">
        <Text size="xs" fw={500}>
          {label}
        </Text>
        <Text size="xs" c="dimmed">
          {remaining}
          {unit ? ` ${unit}` : ""} remaining
        </Text>
      </Group>
      <Progress value={p} size="sm" color={p >= 90 ? "red" : "blue"} mt={2} />
    </Box>
  );
}
